import React from 'react';

export const IconSmallPlusLegacy: React.FC = (props = {}) => (
    <svg height="24" width="24" fill="none" viewBox="0 0 24 24" {...props}>
        {props.children}
        <path d="M13 11V5h-2v6H5v2h6v6h2v-6h6v-2h-6z" fill="#374050" fillRule="evenodd" />
    </svg>
);
